import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type LoginLocationState = { returnTo?: string };

export function Login() {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const { state } = useLocation<LoginLocationState | undefined>();
  const returnTo = state?.returnTo;

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    loginWithRedirect({ appState: { returnTo } });
  }, [isLoading, isAuthenticated, loginWithRedirect, returnTo]);

  return null;
}
